export const MODAL_TITLE = "Success Checklist";
export const SAVE_BTN_TEXT = "Save";
export const CANCEL_BTN_TEXT = "Reset";

export const API_ENDPOINT = "user/marketing-checklist";

export const ERROR_MESSAGES = {
  saveFailed: "Failed to save the data",
};

export const INTRO_TEXT =
  "Key areas of Success Checklist include:";

export const API_KEYS_TO_SKIP = ["id", "userId", "createdAt", "updatedAt"];
